/**
 * Como a ficha de qualidade escreve datas e quantidades — na tela e no papel.
 *
 * Num arquivo só porque são as mesmas duas regras que a tela e o PDF repetiriam, e a
 * primeira divergência seria a data de aprovação saindo `2026-09-10` num e `10/09/2026`
 * no outro, numa ficha que o cliente confere linha a linha.
 */

/** `2026-09-10` vira `10/09/2026` — a data que se lê no canteiro. */
export function formatSheetDate(iso: string | undefined): string {
  if (iso === undefined) return '';
  const [ano, mes, dia] = iso.slice(0, 10).split('-');
  return dia === undefined || mes === undefined || ano === undefined ? '' : `${dia}/${mes}/${ano}`;
}

/**
 * A quantidade com as casas do serviço e a unidade: `12,50 m²`.
 *
 * Sem unidade, só o número — o serviço que ninguém mediu em unidade nenhuma não aparece
 * aqui (a execução exige quantidade), mas o formato não deve inventar uma.
 */
export function formatSheetQuantity(
  quantity: number,
  unit?: { readonly name: string; readonly decimals?: number },
): string {
  const decimals = unit?.decimals ?? 2;
  const text = quantity.toLocaleString('pt-BR', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
  return unit === undefined ? text : `${text} ${unit.name}`;
}

/** `nº 48` ou `nº 48, nº 51` — as NCs como a planilha as cita. */
export function formatNcNumbers(numbers: readonly number[]): string {
  return numbers.map((number) => `nº ${String(number)}`).join(', ');
}
